var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SiteMenuFlyoutLayout",
    {
      attrs: { heading: _vm.heading },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "space-y-4" }, [
        _c(
          "div",
          {
            staticClass: "bg-white rounded-lg p-7",
            style: { backgroundColor: _vm.itemsBackgroundColour },
          },
          [
            _c(
              "ul",
              { staticClass: "text-sm space-y-10" },
              _vm._l(_vm.items, function (item, itemKey) {
                return _c("li", { key: itemKey }, [
                  _c(
                    "a",
                    {
                      staticClass: "flex justify-between items-baseline",
                      attrs: { href: item.link.url },
                    },
                    [
                      _c("div", { staticClass: "flex-shrink w-60" }, [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "uppercase font-semibold tracking-widest",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.link.text) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        item.description
                          ? _c("p", { staticClass: "mt-3" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.description) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-shrink-0 w-3 h-3" },
                        [_c("IconArrowRightShort")],
                        1
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _vm.cta
          ? _c(
              "div",
              {
                staticClass:
                  "bg-white rounded-lg p-7 relative z-10 overflow-hidden",
                style: {
                  backgroundColor: _vm.cta.backgroundColour,
                  color: _vm.cta.textColour,
                },
              },
              [
                _c("div", { staticClass: "w-60 max-w-full space-y-5" }, [
                  _c("h4", { staticClass: "text-lg font-semibold" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.cta.heading) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn-soft",
                      class: {
                        "btn-soft--alt": _vm.cta.textColour === "white",
                      },
                      attrs: {
                        href: _vm.cta.button.url,
                        target: _vm.cta.button.target,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.cta.button.text) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }